import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const DiscoverSidebar = () => {
  const { cats } = useSelector((state) => state.nfts);
  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState('')
  const history = useHistory();
  const query = useQuery();
  const pathname = useLocation().pathname.split('/')[2];
  
  const sortdata = (e)=>{
    const page = query.get('page') || 1;
    const cat = query.get('category');
    const searchQuery = query.get('searchQuery');
    const blockchain = query.get('blockchain');

    if(searchQuery){
      pathname ==='nftdrop' ? history.push(`/browse/nftdrop?searchQuery=${searchQuery}&page=${page}&sort=${e}`) : history.push(`/browse?searchQuery=${searchQuery}&page=${page}&sort=${e}`);
    }else if(cat){
      pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${page}&sort=${e}&category=${cat}`) : history.push(`/browse?page=${page}&sort=${e}&category=${cat}`);
    }else if(blockchain){
      pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${page}&sort=${e}&blockchain=${blockchain}`) : history.push(`/browse?page=${page}&sort=${e}&blockchain=${blockchain}`);
    }else {
      pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${page}&sort=${e}`) : history.push(`/browse?page=${page}&sort=${e}`);
    }
  }
   const sortdatabycat = (e)=>{
  
    //  const cat = query.get('category');
  
     if(e === 'NFT Drops')
     {
       history.push(`/browse/nftdrop?page=1&sort=1`)
     } else{
        pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=1&sort=1&category=${e}`) : history.push(`/browse?page=1&sort=1&category=${e}`);
     }
   }
  
  const clear = () => {
    setSearch({ search: '' });
  };

 
  const searchNFT = (e) => {
    e.preventDefault();
    if (search.trim()) {
      const page = query.get('page') || 1;
      const sort = query.get('sort') || 1;
      pathname ==='nftdrop' ? history.push(`/browse/nftdrop?searchQuery=${search || 'none'}&page=${page}&sort=${sort}`) : history.push(`/browse?searchQuery=${search || 'none'}&page=${page}&sort=${sort}`);
    } else {
      pathname ==='nftdrop' ? history.push('/browse/nftdrop') : history.push('/browse');
    }
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      searchNFT(e);
    }
  };

  const handleNFTMarketRadio = (e) =>{
    setChecked('')
    e.target.value==="NFT" ? history.push(`/browse`) : history.push(`/browse/nftdrop`)
  }

  const handleNFTCollections =(e)=>{
    setChecked('');
    history.push(`/browse/collections`)
  }

  const handleNFTBlockchainRadio = (e) =>{
    const page = query.get('page') || 1;
    const sort = query.get('sort') || 1;
    setChecked(e.target.value)
    // switch(e.target.value){
      // case 'BNB':
        return  pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${1}&sort=${1}&blockchain=${e.target.value}`) : history.push(`/browse?page=${1}&sort=${1}&blockchain=${e.target.value}`);
    //   case 'ETH':
    //     return pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${page}&sort=${sort}&blockchain=${e.target.value}`) ;
    //   case 'MATIC':
    //     return pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${page}&sort=${sort}&blockchain=${e.target.value}`);
    //   default: 
    //     return pathname ==='nftdrop' ? history.push(`/browse/nftdrop?page=${page}&sort=${sort}&blockchain=${e.target.value}`)
    // }
    // e.target.value==="BNB" ? history.push(`/browse`) : history.push(`/browse/nftdrop`)
  }

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <div className='side-bar-area pl-20'>
        <div className='side-bar-widget'>
          <h3 className='title'>
            Filter <a href={pathname ==='nftdrop' ? '/browse/nftdrop' : '/browse'}>Clear All</a>
          </h3>
          <form className='search-form' onSubmit={searchNFT}>
          
            <input
              type='search'
              className='form-control'
              placeholder='Search keyword'
              onKeyDown={handleKeyPress}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <button type='submit'>
              <i className='ri-search-line'></i>
            </button>
          </form>
        </div>

        <div className='side-bar-widget'>
          <h3 className='title'>Sort By</h3>
          <div className='form-group select-group'>
            <select className='form-select form-control' onChange={(e)=>sortdata(e.target.value)}>
              <option value='0' data-display='Sort By (Default)'>
                Sort By (Most Relevant)
              </option>
              <option value='1'>Recently Sold</option>
              <option value='2'>Name: A-Z</option>
              <option value='3'>Name: Z-A</option>
              <option value='4'>Price: High to Low</option>
              <option value='5'>Price: Low to High</option>
              <option value='6'>Recently Listed</option>
              <option value='7'>Oldest Listing</option>
              <option value='8'>Most Liked</option>
            </select>
          </div>
        </div>

        <div className='side-bar-widget-categories'>
          <h3 className='title'>Categories</h3>
          <ul>
            {cats?.map((cat) => {    
              if(cat.name!='NFT Drops'){return(<li key={cat.id}><div onClick={(e)=>sortdatabycat(cat.name)}>
                      <a >
                        {cat.name}
                      </a>
                    </div> </li>);
                  }})}
          </ul>
        </div>

        <div className='checkbox-method-area'>
          <h3 className='title'>Sale Type</h3>
          <div className='col-lg-12 col-md-12'>
            <div className='checkbox-method'>
              <p>
                <input
                  type='radio'
                  id='fixed-price'
                  name='radio-group'
                  value="NFT"
                  onChange={(e)=>handleNFTMarketRadio(e)}
                  
                />
                <label htmlFor='fixed-price'>NFT</label>
              </p>
            </div>
          </div>

          <div className='col-lg-12 col-md-12'>
            <div className='checkbox-method'>
              <p>
                <input
                  type='radio'
                  id='timed-auction'
                  name='radio-group'
                  value="NFT Drop"
                  onChange={(e)=>handleNFTMarketRadio(e)}
                  
                />
                <label htmlFor='timed-auction'>NFT Drop</label>
              </p>
            </div>
          </div>
        </div>

        <div className='checkbox-method-area'>
          <h3 className='title'>Blockchains</h3>
          <div className='col-lg-12 col-md-12'>
            <div className='checkbox-method'>
              <p>
                <input
                  type='radio'
                  id='blockchain-ETH'
                  name='radio-blockchain'
                  value="ETH"
                  onChange={(e)=>handleNFTBlockchainRadio(e)}
                  checked={checked ==='ETH'&& true}
                />
                <label htmlFor='blockchain-ETH'>ETH</label>
              </p>
            </div>
          </div>

          <div className='col-lg-12 col-md-12'>
            <div className='checkbox-method'>
              <p>
                <input
                  type='radio'
                  id='blockchain-BNB'
                  name='radio-blockchain'
                  value="BNB"
                  onChange={(e)=>handleNFTBlockchainRadio(e)}
                  checked={checked ==='BNB'&& true}
                />
                <label htmlFor='blockchain-BNB'>BNB</label>
              </p>
            </div>
          </div>

          <div className='col-lg-12 col-md-12'>
            <div className='checkbox-method'>
              <p>
                <input
                  type='radio'
                  id='blockchain-MATIC'
                  name='radio-blockchain'
                  value="MATIC"
                  onChange={(e)=>handleNFTBlockchainRadio(e)}
                  checked={checked ==='MATIC'&& true}
                />
                <label htmlFor='blockchain-MATIC'>MATIC</label>
              </p>
            </div>
          </div>
        </div>

        <div className='checkbox-method-area'>
          <h3 className='title'>Browse Collections</h3>
          <div className='col-lg-12 col-md-12'>
            <div className='checkbox-method'>
              <p>
                <input
                  type='radio'
                  id='collections'
                  name='radio-collection'
                  value="Collections"
                  onChange={(e)=>handleNFTCollections(e)}
                  
                />
                <label htmlFor='collections'>Collections</label>
              </p>
            </div>
          </div>

         
        </div>


      </div>
    </>
  );
};

export default DiscoverSidebar;
